<template>
  <div class="onlineDoctor">
    <el-tabs class="onlineDoctor_tab" v-model="tabActive" :before-leave="tabSelectBefore">
      <el-tab-pane label="网诊医生管理" name="manage"></el-tab-pane>
      <el-tab-pane v-if="deptId === '0' || deptId === '-1'" label="网诊医生排序" name="sort"></el-tab-pane>
    </el-tabs>
    <div class="page_info">
      <div v-if="tabActive === 'manage'">
        <!-- 条件查询 -->
        <div class="search">
          <el-form :inline="true" :model="manageMap.form">
            <el-form-item label="姓名">
              <el-select allow-create clearable v-model="manageMap.form.doctorName" placeholder="请选择医生" filterable default-first-option>
                <el-option v-for="item in doctorList" :key="item.value" :label="item.label" :value="item.label">
                  <span class="fl">{{ item.label }}</span>
                  <span class="select-flex">{{ item.phone }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="在线状态">
              <el-select v-model="manageMap.form.isOnLine" filterable default-first-option placeholder="请选择医生在线状态">
                <el-option v-for="item in manageMap.statusList" :key="item.value" :label="item.label" :value="item.value"/>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" icon="el-icon-search" @click="manageDoctorSearch">查询</el-button>
              <el-button icon="el-icon-refresh" @click="manageDoctorReset">重置</el-button>
            </el-form-item>
          </el-form>
        </div>
        <!-- 操作按钮 -->
        <div class="button">
          <el-button v-if="deptId === '0' || deptId == '-1'" icon="el-icon-plus" type="primary" @click="addDoctor">新增网诊医生</el-button>
        </div>
        <!-- 医生列表 -->
        <el-table class="manage_table" v-loading="loading" :data="manageMap.list" ref="multipleTable" border>
          <el-table-column type="index" :index="manageIndexMethod" label="序号" width="50"/>
          <el-table-column prop="doctorName" label="姓名" width="100"/>
          <el-table-column prop="webChatPrice" label="咨询费"/>
          <el-table-column prop="isOnLine" label="是否在线">
            <template slot-scope="scope">
              {{scope.row.isOnLine == '0' ? '离线' : '在线'}}
            </template>
          </el-table-column>
          <el-table-column prop="updateBy" label="操作员"/>
          <el-table-column prop="updateTime" label="操作时间"/>
          <el-table-column label="操作" width="240">
            <template slot-scope="scope">
              <el-button v-if="deptId === '0' || deptId == '-1'" icon="el-icon-edit" type="text" @click="editDoctor(scope.row)">编辑</el-button>
              <el-button v-if="deptId === '0' || deptId == '-1'" icon="el-icon-delete" type="text" style="color: #f56c6c" @click="remove(scope.row)">取消网诊</el-button>
            </template>
          </el-table-column>
        </el-table>
        <!-- 分页 -->
        <el-pagination
          :current-page="manageMap.pageNo"
          :page-size="manageMap.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="manageMap.total"
          @current-change="managePageNoChange">
        </el-pagination>
        <!-- 新增或编辑弹框 -->
        <el-dialog class="dialogEdit" :title="dialogTitle" :visible.sync="dialogVisible" width="340px" :before-close="done => $handleClose(done, 'editForm')" :close-on-click-modal="false">
          <el-form label-width="80px" :model="editForm" ref="editForm" :rules="editFormRules" inline>
            <el-form-item label="医生姓名" prop="doctorId">
              <el-select class="online_doctor_input" v-model="editForm.doctorId" placeholder="请选择医生" filterable default-first-option :disabled="dialogTitle == '编辑网诊医生'">
                <el-option v-for="item in doctorList" :key="item.value" :label="item.label" :value="item.value" :disabled="item.disabled">
                  <span class="fl">{{ item.label }}</span>
                  <span class="select-flex">{{ item.phone }}</span>
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="咨询费" prop="webChatPrice">
              <el-input class="online_doctor_input" v-model.trim="editForm.webChatPrice" placeholder="请输入网诊价格" @input="webChatPriceInput"/>
            </el-form-item>
          </el-form>
          <!-- 操作按钮 -->
          <span slot="footer" class="dialog-footer">
            <el-button v-show="dialogTitle == '新增网诊医生'" type="success" @click="addSave">保 存</el-button>
            <el-button v-show="dialogTitle == '编辑网诊医生'" type="success" @click="editSave">保 存</el-button>
            <el-button @click="$cancel('dialogVisible', 'editForm')">取 消</el-button>
          </span>
        </el-dialog>
      </div>

      <!-- 拖拽排序 -->
      <Card v-if="tabActive === 'sort'" class="box0">
        <span slot="title">拖拽排序</span>
        <el-button slot="btn" icon="el-icon-refresh" @click="sortRefresh">刷新</el-button>
        <div slot="content">
          <vuedraggable class="wrapper" v-model="webChatDoctorSortList">
            <transition-group>
              <el-tag v-for="item in webChatDoctorSortList" class="sort_doctor_tag" :key="item.doctorId">{{ item.doctorName }}</el-tag>
            </transition-group>
          </vuedraggable>
          <div class="btnwrap">
            <el-button v-if="deptId === '0' || deptId == '-1'" type="success" icon="el-icon-finished" @click="saveWebChatDoctorSort">保存排序</el-button>
          </div>
        </div>
      </Card>
    </div>
  </div>
</template>

<script lang="js">
import vuedraggable from 'vuedraggable'; // 拖拽组件
import { doctorList, webChatDoctorDragSort, webChatList, doctorEdit, doctorInfo } from "@/api/doctor"; // 医生列表请求
export default {
  name: "WebChatDoctor",
  components: { vuedraggable }, 
  data() {
    return {
      loading: true, // 加载中
      deptId: '',
      tabActive: 'manage',
      doctorList: [],
      manageMap: {
        doctorList: [],
        statusList: [
          {label: '全部', value: null},
          {label: '离线', value: '0'},
          {label: '在线', value: '1'}
        ],
        form: {
          doctorName: null,
          isOnLine: null
        },
        pageNo: 1,
        pageSize: 10,
        list: [],
        total: 0
      },
      webChatDoctorSortList: [],
      dialogVisible: false,
      dialogTitle: "",
      editForm: {},
      editFormRules: {
        doctorId: [{required: true,  message: "医生不能为空！", trigger: "blur"}],
        webChatPrice: [
          {required: true,  message: "网诊价格不能为空！", trigger: "blur"},
          { 
            validator: (rule, value, callback) => {
              if (value === 0 || value === '0') {
                callback(new Error('数值不能为0'));
              } else {
                callback();
              }
            },
            trigger: 'blur'
          }
        ]
      }
    }
  },
  created() {
    this.deptId = sessionStorage.getItem('deptId')
    this.getAllDoctor()
    this.getManageDoctorList()
  },
  methods: {
    tabSelectBefore (activeName) {
      switch (activeName) {
        case 'manage':
          this.manageDoctorReset()
          break;
        case 'sort':
          this.getAllWebChatDoctorList()
          break;
      }
    },
    manageIndexMethod (index) {
      return (this.manageMap.pageNo - 1) * this.manageMap.pageSize + index + 1;
    },
    async getAllDoctor () {
      const res = await doctorList({ status: 0, type: 0 })
      if (res.code == 200) {
        this.doctorList = res.rows.map(v => {
          return {
            label: v.doctorName,
            value: v.doctorId,
            phone: v.phone
          }
        })
      }
    },
    async getManageDoctorList() {
      this.loading = true;
      const res = await webChatList({
        ...this.manageMap.form,
        pageNum: this.manageMap.pageNo,
        pageSize: this.manageMap.pageSize
      })
      this.loading = false
      if (res.code == 200) {
        this.manageMap.list = res.rows
        this.manageMap.total = res.total
      }
    },
    manageDoctorSearch() {
      this.manageMap.pageNo = 1
      this.getManageDoctorList()
    },
    manageDoctorReset() {
      this.manageMap.form.doctorName = null
      this.manageMap.form.isOnLine = null
      this.manageMap.pageNo = 1
      this.getManageDoctorList()
    },
    managePageNoChange(pageNo) {
      this.manageMap.pageNo = pageNo
      this.getManageDoctorList()
    },
    // 新增网诊医生
    addDoctor() {
      this.dialogVisible = true
      this.dialogTitle = "新增网诊医生"
      this.editForm = {
        doctorId: null,
        isWebChat: '1',
        webChatPrice: null,
        webChatSort: null,
        isOnLine: 0,
        pushMethod: '0',
        templateName: '',
        templateType: null,
        templateId: null
      }
    },
    // 编辑医生信息
    editDoctor(row) {
      this.editForm = JSON.parse(JSON.stringify(row))
      this.dialogTitle = "编辑网诊医生"
      this.dialogVisible = true
    },
    // 取消医生网诊
    remove(row) {
      this.$confirm('确认取消该医生网诊吗？').then(_ => {
        row.isWebChat = 0;
        row.webChatPrice = 0;
        row.webChatSort = 0;
        row.isOnLine = 0;
        row.templateId = 0;
        doctorEdit({
          ...row,
          deptId: sessionStorage.getItem('deptId')
        }).then(res => {
          if (res.code == 200) this.$message.success("修改网诊医生信息成功！")

          this.dialogVisible = false
          this.getManageDoctorList()
          this.$refs['editForm'].resetFields()
        });
      }).catch(_ => {});
    },
    webChatPriceInput (value) {
      let result = value.replace(/[^\d.]/g, '')
        .replace(/^\./g, '')
        .replace(/\.{2,}/g, '.')
        .replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
        .replace(/^(\-*)(\d+)\.(\d\d).*$/, '$1$2.$3')
      if (result.startsWith('-')) {
        result = result.substring(1)
      }
      this.editForm.webChatPrice = result
    },
    // 保存新增
    addSave() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          doctorEdit({
            ...this.editForm,
            deptId: sessionStorage.getItem('deptId'),
            isAddWebChat: 1
          }).then(res => {
            if (res.code == 200) this.$message.success("新增网诊医生成功！");
            this.dialogVisible = false;
            this.getManageDoctorList()
            this.$refs['editForm'].resetFields();
          });
        } else return false;
      })
    },
    // 保存医生修改
    editSave() {
      this.$refs['editForm'].validate((valid) => {
        if (valid) {
          doctorEdit({
            ...this.editForm,
            deptId: sessionStorage.getItem('deptId'),
            isOnLine: null
          }).then(res => {
            let {code} = res;
            if (code == 200) this.$message.success("修改网诊医生信息成功！");
            this.dialogVisible = false;
            this.getManageDoctorList()
            this.$refs['editForm'].resetFields();
          });
        } else return false;
      })
    },

    // 请求所有网诊医生列表列表
    async getAllWebChatDoctorList() {
      const res = await webChatList()
      if (res.code === 200 && res.total > 0) {
        this.webChatDoctorSortList = res.rows
      }
    },
    sortRefresh () {
      this.getAllWebChatDoctorList()
    },
    // 保存网诊医生排序
    async saveWebChatDoctorSort() {
      let { code } = await webChatDoctorDragSort(this.webChatDoctorSortList);
      if (code == 200) {
        this.$message.success("网诊医生排序成功！")
        this.getAllWebChatDoctorList()
      }
    }
  }
};
</script>
<style lang="less" scope>
.onlineDoctor {
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  overflow-y: auto;
  background-color: #FFFFFF;
}

.page_info {
  box-sizing: border-box;
  padding: 20px;
}

.manage_table {
  margin: 12px 0 0 0;
}

.online_doctor_input {
  width: 200px;
}

.sort_doctor_tag {
  margin: 0 10px 10px 0;
  cursor: pointer;
}
</style>